import * as PIXI from "pixi.js";
import SecondPart from "../HTPSecondPart";
import HTPEllipseShrinkAnimation from "../../../animations/HTPEllipseShrinkAnimation";
import { HTPEllipseColor } from "../../../types/Enum";

export default class HTPEllipse extends PIXI.Graphics {
  SecondPart = SecondPart.getInstance();
  constructor(color: HTPEllipseColor) {
    super();
    this.ellipse(0, 0, 46, 56)
      .stroke({ color, width: 7 })
    this.scale = 1;
    const delay = color == HTPEllipseColor.sameType ? 1000 : 0;
    new HTPEllipseShrinkAnimation(this, delay);
    this.addToLayer();
  }
  addToLayer() {
    this.SecondPart.addChild(this);
  }
}